import React from 'react';
import { callApiSystemSetting, REDUCER_NAME } from '../../sidebar/reducer';
import { ToggleSwitch } from './../../../common/toggle-switch';
import { THEMES } from '../../../../configs/LayoutConfig';
import { connect } from 'react-redux';
import { changeUITheme, saveTheme } from './../../../helpers/Theme';
import { changeTheme } from './../../../app/reducer';
import FontSize from './FontSize';

class Theme extends React.Component {
  changeTheme = () => {
    const { theme, changeTheme, dataSystem, callApiSystemSetting } = this.props;
    const newTheme = theme === THEMES.LIGHT ? THEMES.DARK : THEMES.LIGHT;
    callApiSystemSetting({
      ...dataSystem,
      theme: newTheme,
    });
    changeTheme(newTheme);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { theme } = this.props;

    if (theme !== prevProps.theme) {
      changeUITheme(theme);
      saveTheme(theme);
    }
  }

  render() {
    const { theme } = this.props;

    return (
      <div className="time-and-mode">
        <FontSize />
        <div className="mode d-flex align-items-center">
          <span>
            <i className="icon-sun" />
          </span>
          <span className="ml-1 mr-1">
            <ToggleSwitch
              isActive={theme === THEMES.DARK}
              handleToggle={this.changeTheme}
            />
          </span>
          <span>
            <i className="icon-moon" />
          </span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    theme: state.theme,
    dataSystem: state[REDUCER_NAME].settingSystem.dataSystem,
  };
};

const mapDispatchToProps = {
  changeTheme,
  callApiSystemSetting,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Theme);
